import { attachFilesForSelectedAction } from './helpers/attachFilesForSelectedAction';
import createFilePickerUserConfiguration from './helpers/configuration/createFilePickerUserConfiguration';
import { CreateAttachmentHandler } from '../types/CreateAttachmentHandler';
import { InsertLinkHandler } from '../types/InsertLinkHandler';
import {
    FilePickerUserConfiguration,
    FileProviderItemType,
    FileProviderItemViewState,
    lazyActionsPanel,
    SelectedFilesSource,
    ComposeUniqueState,
} from 'owa-filepicker';
import { FileProviderType } from 'owa-fileprovider-store';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import * as trace from 'owa-trace';

export default async function attachmentActionsPanel(
    createAttachmentHandler: CreateAttachmentHandler,
    insertLinkHandler: null,
    files: File[] | FileProviderItemViewState[],
    selectedFileProviderType: null,
    selectedFileSource: SelectedFilesSource.LocalComputerFiles,
    maxClassicAttachmentSize: number,
    composeUniqueState: ComposeUniqueState,
    targetWindow: Window
): Promise<void>;
export default async function attachmentActionsPanel(
    createAttachmentHandler: CreateAttachmentHandler,
    insertLinkHandler: InsertLinkHandler,
    files: File[] | FileProviderItemViewState[],
    selectedFileProviderType: AttachmentDataProviderType,
    selectedFileSource: SelectedFilesSource.ProviderFiles,
    maxClassicAttachmentSize: number,
    composeUniqueState: ComposeUniqueState,
    targetWindow: Window
): Promise<void>;
export default async function attachmentActionsPanel(
    createAttachmentHandler: CreateAttachmentHandler,
    insertLinkHandler: InsertLinkHandler | null,
    files: File[] | FileProviderItemViewState[],
    selectedFileProviderType: FileProviderType | null,
    selectedFileSource: SelectedFilesSource,
    maxClassicAttachmentSize: number,
    composeUniqueState: ComposeUniqueState,
    targetWindow: Window
): Promise<void> {
    const actionsPanel = await lazyActionsPanel.import();
    const filePickerUserConfiguration: FilePickerUserConfiguration = createFilePickerUserConfiguration();

    try {
        if (!files || files.length == 0) {
            throw new Error('files length cannot be 0.');
        }
        return actionsPanel(
            files,
            maxClassicAttachmentSize,
            selectedFileProviderType,
            files[0].type === FileProviderItemType.Group,
            files.length > 1,
            selectedFileSource,
            targetWindow,
            filePickerUserConfiguration,
            composeUniqueState
        )
            .then(action => {
                attachFilesForSelectedAction(
                    createAttachmentHandler,
                    insertLinkHandler,
                    files,
                    selectedFileSource,
                    action,
                    false /* supportsInsertLink */,
                    targetWindow
                );
            })
            .catch(() => {
                // No action was selected
            });
    } catch (error) {
        trace.errorThatWillCauseAlert(
            `Error creating the action panel. Attaching or sharing files might not work! ${error}`
        );
    }
}
